import React, { ComponentType } from 'react';
import styled from 'styled-components';
import { COLORS, SPACING } from '../../style';

interface ServiceCardProps {
  title: string;
  Icon: ComponentType;
  href: string;
  buttonText?: string;
}

const CardContainer = styled.a`
  background: ${COLORS.white};
  border: 2px solid transparent;
  border-radius: 16px;
  padding: ${SPACING.md};
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  gap: ${SPACING.sm};
  cursor: pointer;
  text-decoration: none;
  transition: all 0.3s ease;
  box-shadow: 0 4px 12px rgba(15, 61, 76, 0.08);
  position: relative;
  overflow: hidden;
  min-height: 240px;

  &::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    height: 4px;
    background: linear-gradient(90deg, ${COLORS.blue} 0%, ${COLORS.green} 100%);
    transform: scaleX(0);
    transition: transform 0.3s ease;
  }

  &:hover {
    transform: translateY(-6px);
    box-shadow: 0 8px 20px rgba(15, 61, 76, 0.15);
    border-color: ${COLORS.green};

    &::before {
      transform: scaleX(1);
    }

    .icon-wrapper {
      transform: scale(1.1);
      background: ${COLORS.blue};

      svg {
        color: ${COLORS.white};
      }
    }

    h2 {
      color: ${COLORS.green};
    }

    button {
      background: ${COLORS.blue};
      transform: scale(1.02);
    }
  }

  .icon-wrapper {
    width: 56px;
    height: 56px;
    border-radius: 12px;
    background: linear-gradient(135deg, rgba(75, 166, 156, 0.15) 0%, rgba(15, 61, 76, 0.15) 100%);
    display: flex;
    align-items: center;
    justify-content: center;
    transition: all 0.3s ease;

    svg {
      font-size: 28px;
      color: ${COLORS.blue};
      transition: all 0.3s ease;
    }
  }

  h2 {
    font-size: 18px;
    color: ${COLORS.blue};
    font-weight: 700;
    margin-top: ${SPACING.sm};
    transition: all 0.3s ease;
  }
`;

const CallButton = styled.button`
  color: ${COLORS.white};
  font-size: 16px;
  font-weight: 600;
  background: ${COLORS.wpp};
  border-radius: 12px;
  padding: 12px ${SPACING.sm};
  cursor: pointer;
  transition: all 0.3s ease;
  box-shadow: 0 2px 8px rgba(37, 211, 102, 0.3);

  &:hover {
    box-shadow: 0 4px 12px rgba(37, 211, 102, 0.4);
  }
`;

const ServiceCard = ({ title, Icon, href, buttonText = 'Chamar no WhatsApp' }: ServiceCardProps) => {
  return (
    <CardContainer href={href} target="_blank" rel="noopener noreferrer">
      <div>
        <div className="icon-wrapper">
          <Icon />
        </div>
        <h2>{title}</h2>
      </div>
      <CallButton>{buttonText}</CallButton>
    </CardContainer>
  );
};

export default ServiceCard;
